module.exports = __webpack_public_path__ + "img/CCRC-t-20533-003-474x317.d66bf95d.jpg";